import { menuItemClasses } from "@mui/material";
const MuiMenuItem = {
    styleOverrides: {
        root: ({ theme })=>({
                minHeight: '36px',
                padding: theme.spacing(1, 2),
                '&:hover': {
                    backgroundColor: theme.palette.action.hover
                },
                [`&.${menuItemClasses.selected}`]: {
                    backgroundColor: theme.palette.action.menuSelected
                }
            })
    }
};
export { MuiMenuItem };

//# sourceMappingURL=menuitem-overrides.js.map